const conditionReportPhotos = [
  'Driver Side Front',
  'Passenger Side Front',
  'Driver Side Rear',
  'Passenger Side Rear',
  'Odometer',
  'Dash VIN',
]

export default conditionReportPhotos
